<template>
  <div>
    <h1>Chyba</h1>
    <h2>{{data.header}}</h2>
    <p>{{data.msg}}</p>
  </div>
</template>

<script>
  export default {
    props: {
      data: {
        value: Object,
      }
    }
  }
</script>

<style scoped>
</style>
